module.exports = __webpack_public_path__ + "static/media/brackets.1e5d8abb.svg";